import React, { useCallback, useEffect } from "react";
import { makeStyles, TextField } from "@material-ui/core";
import { TextboxColor, TextboxSize, TextboxVariant } from "../../models/element";

interface TextboxStyleProps {
    // サイズ
    size?: TextboxSize;
    // 配色
    color?: TextboxColor;
    // 表示形式
    variant?: TextboxVariant;
    // 活性化
    isActive?: boolean;
}

interface TextboxProps extends TextboxStyleProps {
    // 要素ID
    id?: string;
    // 文字列
    children?: string;
    // placeholder文字列
    placeholder?: string;
    // 自動補足有無
    autoComplete?: boolean;
    // 複数行入力可能
    multiline?: boolean;
    // 最大表示行数
    rows?: number;
    // エラー有無
    error?: boolean;
    // エラーメッセージ
    helperText?: string;
    // クリックイベント
    onChange?: (value: string) => void;
}

const useStyles = makeStyles({
    noScrollbar: {
        overflowY: "scroll",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        display: "inline-grid",
        '&::-webkit-scrollbar': { display: "none" }
    },
});

const PuiTextbox = React.forwardRef<HTMLInputElement, TextboxProps>(function PuiTextbox(props, ref) {
    const classes = useStyles();

    // パラメータ初期化
    const { 
        id, children = "", placeholder = "", autoComplete = false, multiline = false, rows = 1, error = false, helperText = "", onChange, 
        size = "small", color = "secondary", variant = "outlined", isActive = true 
    } = props;
    const [val, setVal] = React.useState("");

    // Children監視
    useEffect(() => {
        setVal(children);
    }, [children]);

    // 内容編集イベント
    const handleChange = useCallback((event: any) => {
        setVal(String(event.target.value));
        if (onChange) {
            onChange(String(event.target.value));
        }
    }, [onChange]);

    return (
        <TextField 
            id={id}
            inputRef={ref}
            size={size}
            color={color}
            variant={variant}
            autoComplete={autoComplete ? "on" : "off"}
            multiline={multiline}
            minRows={rows}
            value={val}
            error={error}
            helperText={helperText}
            placeholder={placeholder}
            disabled={!isActive}
            onChange={handleChange}
            fullWidth
            inputProps={{className: classes.noScrollbar}}
        />
    );
});

export default PuiTextbox;
